import React, { FC } from 'react';
import { Button, Form } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useNavigate } from 'react-router-dom';
import { NewPasswordFormField } from 'common/components/NewPasswordFormField';
import { NewPasswordConfirmFormField } from 'common/components/NewPasswordConfirmFormField';
import { ERoute } from 'common/const/route.enum';
import { IFormValue } from 'common/models';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { AuthCardLogo } from 'entities/Auth/components/AuthCardLogo';
import { AuthCardFooter } from 'entities/Auth/components/AuthCardFooter';
import { restorePassword, selectIsAuthLoading, setAuthError } from 'entities/Auth/Auth.slice';

interface IComponentProps {
  hash?: string;
}

export const RestorePasswordCard: FC<IComponentProps> = ({ hash }) => {
  const dispatch = useAppDispatch();
  // auth
  const isAuthLoading = useAppSelector(selectIsAuthLoading);

  const [form] = useForm();
  const navigate = useNavigate();

  const onSubmit = ({ password }: IFormValue) => {
    dispatch(setAuthError(null));

    if (hash) {
      dispatch(
        restorePassword({
          hash,
          password,
          onSuccess: () => navigate(ERoute.Login),
        }),
      );
    }
  };

  return (
    <div className="auth-card">
      <AuthCardLogo />

      <div className="auth-card__content">
        <Form className="auth-card__content-form" form={form} layout="vertical" requiredMark={false} onFinish={onSubmit}>
          <div className="mb-11 auth-card__content-form-title">Придумайте надежный пароль для входа в систему</div>

          <NewPasswordFormField className="w-100" label="Ваш пароль*" name="password" />

          <NewPasswordConfirmFormField className="w-100 mb-11" label="Подтвердите пароль*" newPasswordName="password" />

          <Button className="button-lg primary w-100" loading={isAuthLoading} htmlType="submit">
            Войти в систему
          </Button>
        </Form>
      </div>

      <AuthCardFooter content="СПРАУТ. Система управления закупками." />
    </div>
  );
};
